module.exports = __webpack_public_path__ + "be6959d0e93684fccd6037d4a989a5ac.png";